var map = {
	"./SKP_myjnia_desktop.png": 2246,
	"./SKP_myjnia_mobile.png": 39628,
	"./breaks.svg": 82100,
	"./checkbox.svg": 32362,
	"./computer.svg": 74322,
	"./conditioner.svg": 36027,
	"./correct.svg": 59774,
	"./drop.svg": 51221,
	"./glass.svg": 99546,
	"./light.svg": 13169,
	"./protect.svg": 24783,
	"./seat.svg": 13729,
	"./shine.svg": 68529,
	"./snow.svg": 83892,
	"./tire.svg": 84466,
	"./update.svg": 4656,
	"./wax.svg": 29525,
	"./wind.svg": 41019
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17004;